export const trimObjectStrings = obj => {
  Object.keys(obj).map(
    // eslint-disable-next-line no-return-assign
    k => (obj[k] = typeof obj[k] === "string" ? obj[k].trim() : obj[k])
  );
  return obj;
};
